<template>
  <div class="organization" id="organization">
    <el-row>
      <el-col class="org_left">
        <h2>组织架构</h2>
        <p class="underline"></p>
        <p class="org-p">Organization</p>
      </el-col>
      <el-col class="org_right">
        <img :src="basic.us_structure_image" alt />
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      basic: {}
    };
  },
  created() {
    this.basic = this.$cache.get("aboutConfig");
  }
};
</script>
<style lang="less" scoped>
.organization {
  width: 1200px;
  height: 408px;
  margin: 0 auto;
  background: #fff;
  margin-top: 36px;

  .el-row {
    display: flex;
    align-items: center;

    .org_left {
      width: 305px;
      min-width: 305px;
      padding: 48px;
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 41px;
      }
      .org-p {
        font-size: 24px;
        color: #999999;
      }
    }
    .org_right {
      font-size: 0;
      height: 408px;
      img {
        width: 100%;
        height: 408px;
      }
    }
  }
}
</style>


